// src/app/authz/role-permission.map.ts
import { PERMISSIONS } from './permissions';

export const ROLE_PERMISSIONS: Record<string, string[]> = {
  SYSTEM_ADMIN: [
    // Dashboard
    PERMISSIONS.DASHBOARD.READ,

    // Import
    PERMISSIONS.IMPORT.SHIPMENTS.READ,
    PERMISSIONS.IMPORT.SHIPMENTS.WRITE,
    PERMISSIONS.IMPORT.WORK_ORDERS.READ,
    PERMISSIONS.IMPORT.WORK_ORDERS.WRITE,
    PERMISSIONS.IMPORT.RECEIVING.READ,
    PERMISSIONS.IMPORT.RECEIVING.WRITE,

    // Expenses
    PERMISSIONS.EXPENSES.READ,
    PERMISSIONS.EXPENSES.WRITE,
    PERMISSIONS.EXPENSES.AP.READ,

    // Expenses
    // PERMISSIONS.EXPENSES.READ,
    PERMISSIONS.EXPENSES.AP.READ,
    PERMISSIONS.EXPENSES.AP.WRITE,

    // Sales
    PERMISSIONS.SALES.SALE_ORDER.READ,
    PERMISSIONS.SALES.SALE_ORDER.WRITE,
    PERMISSIONS.SALES.BOL.READ,
    PERMISSIONS.SALES.BOL.WRITE,
    PERMISSIONS.SALES.SALE_INVOICE.READ,
    PERMISSIONS.SALES.SALE_INVOICE.WRITE,
    PERMISSIONS.SALES.COST_REPORT.READ,

    // Inventory
    PERMISSIONS.INVENTORY.ADJUSTMENT.READ,
    PERMISSIONS.INVENTORY.ADJUSTMENT.WRITE,
    PERMISSIONS.INVENTORY.REPORT.READ,
    PERMISSIONS.INVENTORY.REPORT.WRITE,
    PERMISSIONS.INVENTORY.MOVEMENT.READ,
    PERMISSIONS.INVENTORY.MOVEMENT.WRITE,
    PERMISSIONS.INVENTORY.COSTING.READ,

    // Settings
    PERMISSIONS.SETTINGS.USER_MANAGEMENT.READ,
    PERMISSIONS.SETTINGS.USER_MANAGEMENT.WRITE,

    // Reports
    PERMISSIONS.REPORTS.SHIPMENTS.READ,
    PERMISSIONS.REPORTS.SHIPMENTS.WRITE,
    PERMISSIONS.REPORTS.AP.READ,
    PERMISSIONS.REPORTS.AP.WRITE,
    PERMISSIONS.REPORTS.AR.READ,
    PERMISSIONS.REPORTS.AR.WRITE,
    PERMISSIONS.REPORTS.INVENTORY.READ,
    PERMISSIONS.REPORTS.INVENTORY.WRITE,
    PERMISSIONS.REPORTS.INVENTORY_COSTING.READ,
    PERMISSIONS.REPORTS.INVENTORY_COSTING.WRITE,
    PERMISSIONS.REPORTS.GROSS_MARGIN.READ,
    PERMISSIONS.REPORTS.FINANCIAL_STMNT.READ,
    PERMISSIONS.REPORTS.USERS.READ,
    PERMISSIONS.REPORTS.USERS.WRITE,
  ],

  AP_AR: [
    // Import
    PERMISSIONS.IMPORT.SHIPMENTS.READ,
    PERMISSIONS.IMPORT.SHIPMENTS.WRITE,
    PERMISSIONS.IMPORT.WORK_ORDERS.READ,
    PERMISSIONS.IMPORT.WORK_ORDERS.WRITE,
    PERMISSIONS.IMPORT.RECEIVING.READ,
    PERMISSIONS.IMPORT.RECEIVING.WRITE,

    // Expenses
    PERMISSIONS.EXPENSES.READ,
    PERMISSIONS.EXPENSES.WRITE,
    PERMISSIONS.EXPENSES.AP.READ,

    // Sales
    PERMISSIONS.SALES.SALE_ORDER.READ,
    PERMISSIONS.SALES.SALE_ORDER.WRITE,
    PERMISSIONS.SALES.BOL.READ,
    PERMISSIONS.SALES.BOL.WRITE,
    PERMISSIONS.SALES.SALE_INVOICE.READ,
    PERMISSIONS.SALES.SALE_INVOICE.WRITE,
    // PERMISSIONS.SALES.COST_REPORT.READ,

    // Inventory
    PERMISSIONS.INVENTORY.ADJUSTMENT.WRITE,
    PERMISSIONS.INVENTORY.ADJUSTMENT.READ,
    PERMISSIONS.INVENTORY.REPORT.READ,
    PERMISSIONS.INVENTORY.MOVEMENT.READ,
    PERMISSIONS.INVENTORY.COSTING.READ,

    // Reports
    PERMISSIONS.REPORTS.SHIPMENTS.READ,
    PERMISSIONS.REPORTS.SHIPMENTS.WRITE,
    PERMISSIONS.REPORTS.AP.READ,
    PERMISSIONS.REPORTS.AP.WRITE,
    PERMISSIONS.REPORTS.AR.READ,
    PERMISSIONS.REPORTS.AR.WRITE,
  ],

  COSTING_INVENTORY: [
    // Dashboard
    PERMISSIONS.DASHBOARD.READ,

    // Import
    PERMISSIONS.IMPORT.SHIPMENTS.READ,
    PERMISSIONS.IMPORT.SHIPMENTS.WRITE,
    PERMISSIONS.IMPORT.WORK_ORDERS.READ,
    PERMISSIONS.IMPORT.WORK_ORDERS.WRITE,
    PERMISSIONS.IMPORT.RECEIVING.READ,
    PERMISSIONS.IMPORT.RECEIVING.WRITE,

    // Expenses
    PERMISSIONS.EXPENSES.READ,
    PERMISSIONS.EXPENSES.WRITE,
    PERMISSIONS.EXPENSES.AP.READ,

    // Sales
    PERMISSIONS.SALES.SALE_ORDER.READ,
    PERMISSIONS.SALES.BOL.READ,
    PERMISSIONS.SALES.SALE_INVOICE.READ,
    PERMISSIONS.SALES.INCOME_STMNT.READ,
    PERMISSIONS.SALES.COST_REPORT.READ,

    // Inventory
    PERMISSIONS.INVENTORY.ADJUSTMENT.READ,
    PERMISSIONS.INVENTORY.ADJUSTMENT.WRITE,
    PERMISSIONS.INVENTORY.REPORT.READ,
    PERMISSIONS.INVENTORY.REPORT.WRITE,
    PERMISSIONS.INVENTORY.MOVEMENT.READ,
    PERMISSIONS.INVENTORY.MOVEMENT.WRITE,
    PERMISSIONS.INVENTORY.COSTING.READ,

    // Reports
    PERMISSIONS.REPORTS.SHIPMENTS.READ,
    PERMISSIONS.REPORTS.SHIPMENTS.WRITE,
    PERMISSIONS.REPORTS.AP.READ,
    PERMISSIONS.REPORTS.AP.WRITE,
    PERMISSIONS.REPORTS.AR.READ,
    PERMISSIONS.REPORTS.AR.WRITE,
    PERMISSIONS.REPORTS.INVENTORY.READ,
    PERMISSIONS.REPORTS.INVENTORY.WRITE,
    PERMISSIONS.REPORTS.INVENTORY_COSTING.READ,
  ],

  ACCOUNTING: [
    // Dashboard
    PERMISSIONS.DASHBOARD.READ,

    // Import
    PERMISSIONS.IMPORT.SHIPMENTS.READ,
    PERMISSIONS.IMPORT.SHIPMENTS.WRITE,
    PERMISSIONS.IMPORT.WORK_ORDERS.READ,
    PERMISSIONS.IMPORT.WORK_ORDERS.WRITE,
    PERMISSIONS.IMPORT.RECEIVING.READ,
    PERMISSIONS.IMPORT.RECEIVING.WRITE,

    // Expenses
    PERMISSIONS.EXPENSES.READ,
    PERMISSIONS.EXPENSES.WRITE,
    PERMISSIONS.EXPENSES.AP.READ,

    // Sales
    PERMISSIONS.SALES.SALE_ORDER.READ,
    PERMISSIONS.SALES.SALE_ORDER.WRITE,
    PERMISSIONS.SALES.BOL.READ,
    PERMISSIONS.SALES.BOL.WRITE,
    PERMISSIONS.SALES.SALE_INVOICE.READ,
    PERMISSIONS.SALES.SALE_INVOICE.WRITE,
    PERMISSIONS.SALES.INCOME_STMNT.READ,
    PERMISSIONS.SALES.COST_REPORT.READ,

    // Inventory
    PERMISSIONS.INVENTORY.ADJUSTMENT.READ,
    PERMISSIONS.INVENTORY.ADJUSTMENT.WRITE,
    PERMISSIONS.INVENTORY.REPORT.READ,
    PERMISSIONS.INVENTORY.REPORT.WRITE,
    PERMISSIONS.INVENTORY.MOVEMENT.READ,
    PERMISSIONS.INVENTORY.MOVEMENT.WRITE,
    PERMISSIONS.INVENTORY.COSTING.READ,

    // Reports
    PERMISSIONS.REPORTS.SHIPMENTS.READ,
    PERMISSIONS.REPORTS.SHIPMENTS.WRITE,
    PERMISSIONS.REPORTS.AP.READ,
    PERMISSIONS.REPORTS.AP.WRITE,
    PERMISSIONS.REPORTS.AR.READ,
    PERMISSIONS.REPORTS.AR.WRITE,
    PERMISSIONS.REPORTS.INVENTORY.READ,
    PERMISSIONS.REPORTS.INVENTORY.WRITE,
    PERMISSIONS.REPORTS.INVENTORY_COSTING.READ,
    PERMISSIONS.REPORTS.GROSS_MARGIN.READ,
    PERMISSIONS.REPORTS.FINANCIAL_STMNT.READ,
  ],

  GM: [
    // Dashboard
    PERMISSIONS.DASHBOARD.READ,

    // Import
    PERMISSIONS.IMPORT.SHIPMENTS.READ,
    PERMISSIONS.IMPORT.SHIPMENTS.WRITE,
    PERMISSIONS.IMPORT.WORK_ORDERS.READ,
    PERMISSIONS.IMPORT.WORK_ORDERS.WRITE,
    PERMISSIONS.IMPORT.RECEIVING.READ,
    PERMISSIONS.IMPORT.RECEIVING.WRITE,

    // Expenses
    PERMISSIONS.EXPENSES.READ,
    PERMISSIONS.EXPENSES.WRITE,
    PERMISSIONS.EXPENSES.AP.READ,
    PERMISSIONS.EXPENSES.AP.WRITE,

    // Sales
    PERMISSIONS.SALES.SALE_ORDER.READ,
    PERMISSIONS.SALES.SALE_ORDER.WRITE,
    PERMISSIONS.SALES.BOL.READ,
    PERMISSIONS.SALES.BOL.WRITE,
    PERMISSIONS.SALES.SALE_INVOICE.READ,
    PERMISSIONS.SALES.SALE_INVOICE.WRITE,
    PERMISSIONS.SALES.INCOME_STMNT.READ,
    PERMISSIONS.SALES.COST_REPORT.READ,

    // Inventory
    PERMISSIONS.INVENTORY.ADJUSTMENT.READ,
    PERMISSIONS.INVENTORY.ADJUSTMENT.WRITE,
    PERMISSIONS.INVENTORY.REPORT.READ,
    PERMISSIONS.INVENTORY.REPORT.WRITE,
    PERMISSIONS.INVENTORY.MOVEMENT.READ,
    PERMISSIONS.INVENTORY.MOVEMENT.WRITE,
    PERMISSIONS.INVENTORY.COSTING.READ,

    // Settings
    PERMISSIONS.SETTINGS.USER_MANAGEMENT.READ,
    PERMISSIONS.SETTINGS.USER_MANAGEMENT.WRITE,
  ],

  CEO: [
    // Dashboard
    PERMISSIONS.DASHBOARD.READ,

    // Import
    // PERMISSIONS.IMPORT.SHIPMENTS.READ,
    // PERMISSIONS.IMPORT.WORK_ORDERS.READ,
    // PERMISSIONS.IMPORT.RECEIVING.READ,

    // Expenses
    // PERMISSIONS.EXPENSES.READ,
    PERMISSIONS.EXPENSES.AP.READ,
    PERMISSIONS.EXPENSES.AP.WRITE,

    // Sales
    // PERMISSIONS.SALES.SALE_ORDER.READ,
    // PERMISSIONS.SALES.BOL.READ,
    // PERMISSIONS.SALES.SALE_INVOICE.READ,
    // PERMISSIONS.SALES.INCOME_STMNT.READ,
    PERMISSIONS.SALES.COST_REPORT.READ,

    // Inventory
    // PERMISSIONS.INVENTORY.REPORT.READ,
    // PERMISSIONS.INVENTORY.MOVEMENT.READ,
    // PERMISSIONS.INVENTORY.COSTING.READ,

    // Settings
    // PERMISSIONS.SETTINGS.USER_MANAGEMENT.READ,

    // Reports
    // PERMISSIONS.REPORTS.SHIPMENTS.READ,
    // PERMISSIONS.REPORTS.AP.READ,
    // PERMISSIONS.REPORTS.AR.READ,
    // PERMISSIONS.REPORTS.INVENTORY.READ,
    // PERMISSIONS.REPORTS.INVENTORY_COSTING.READ,
    // PERMISSIONS.REPORTS.GROSS_MARGIN.READ,
    // PERMISSIONS.REPORTS.FINANCIAL_STMNT.READ,
    // PERMISSIONS.REPORTS.USERS.READ,
  ],
};
